import {debounce} from "lodash";
import SwipeContainer from "../../swipe-container/SwipeContainer";
import Slick from 'vue-slick';

const ADAPTIVE_WIDTH = 768;

export default {
	data() {
		return {
			products: window.compare.productsData,
			categories: window.compare.categoriesData,
			isLoading: true,
			windowWidth: window.innerWidth,
			activeCategory: {},
			floatBlock: false,
			io: null,
			currentScrollLeft: 0,
			activeProductLeft: "",
			activeProductRight: "",
			slickOptions: {
				dots: false,
				infinite: true,
				speed: 500,
				fade: true,
				cssEase: 'linear',
				arrows: false,
			},
			addedToCart: [],
			activeCategories: []
		}
	},
	components: {
		SwipeContainer,
		Slick
	},
	computed: {
		hasProducts() {
			return Object.keys(this.products).length;
		},
		isAdaptive() {
			return (this.windowWidth <= ADAPTIVE_WIDTH) ? true : false;
		},
		activeProducts() {
			return this.activeCategory && this.activeCategory.products.map(id => this.products[id]);
		},
		leftProductIndex() {
			return this.activeCategory && this.activeCategory.products.indexOf(this.activeProductLeft) + 1;
		},
		rightProductIndex() {
			return this.activeCategory && this.activeCategory.products.indexOf(this.activeProductRight) + 1;
		},
	},
	methods: {
		update() {
			this.$forceUpdate()
		},
		updateScroll(value) {
			this.currentScrollLeft = value;
		},
		sendAction(data, cb) {
			$.ajax({
				url: "",
				type: "POST",
				dataType: 'json',
				data: data,
				beforeSend: () => {
					this.isLoading = true;
				},
				success: (res) => {
					cb(res);
				},
				complete: (data) => {
					this.isLoading = false;
				}
			});
		},
		actionCb(data) {
			if (data.success) {
				this.products = data.products;
				this.categories = data.categories;
				this.activeCategory = data.categories.find(category => category.name === this.activeCategory.name) || data.categories[0];
			}
		},
		setActiveCategory(category) {
			this.activeCategory = category;
		},
		setDifference(status) {
			this.sendAction({
				action: "DIFFERENT",
				DIFFERENT: status
			}, this.actionCb);
		},
		removeProduct(id) {
			this.sendAction({
				action: "DELETE_PRODUCT",
				ID: id
			}, this.actionCb);
		},
		removeAllProducts() {
			this.sendAction({
				action: "CLEAR_ALL"
			}, this.actionCb);
		},
		setActiveProduct(isLeft, id) {
			let propName = (isLeft) ? "activeProductLeft" : "activeProductRight";
			this[propName] = id;
		},
		handleSliderBeforeChange(isLeft, e, slick, currentSlide, nextSlide) {
			let $next = $(`[data-slick-index=${nextSlide}]`, slick.$slider);
			let id = $("[data-item]", $next).attr("data-item");
			this.setActiveProduct(isLeft, id);
		},
		handleSliderInit(e, isLeft) {
			let $activeItem = $(".slick-current", e.currentTarget);
			if (!isLeft) {
				let $next = $activeItem.next();
				if ($next.length) {
					$activeItem = $activeItem.next();
					setTimeout(() => $(e.currentTarget).slick("next"), 0);
				}
			}
			let id = $("[data-item]", $activeItem).attr("data-item");
			this.setActiveProduct(isLeft, id);
		},
		initProductCards() {
			this.addItemsToCart(this.addedToCart);
			window.initFullProductCard();

			let cards = [...this.$el.querySelectorAll("[data-product-card]")];
			cards.forEach(card => {
				let id = card.querySelector("[data-item]").dataset.item;
				let remove = card.querySelector("[data-product-card-remove]");
				remove.addEventListener("click", () => this.removeProduct(id));
				let toCart = card.querySelector("[data-to-cart-btn]");
				if (toCart) {
					toCart.addEventListener("click", () => this.addedToCart.push(id));
				}
			});
		},
		ioCallback(entries) {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					this.floatBlock = false;
				} else {
					this.floatBlock = true;
				}
			});
		},
		initSliderEvents() {
			let sliders = [this.$refs.leftSlider, this.$refs.rightSlider];
			sliders.forEach((slider, idx) => {
				let isLeft = idx === 0;
				slider.$on("beforeChange", (...slickArgs) => {
					this.handleSliderBeforeChange(isLeft, ...slickArgs);
				});
			});
		},
		destroySliders() {
			let sliders = [this.$refs.leftSlider, this.$refs.rightSlider];
			sliders.forEach(slider => {
				let $slider = $("[data-slider]", slider);
				$slider.slick("unslick")
			});
		},
		calcSwipeControlsPosition(fixed = false) {
			if (fixed) {
				let top = `${this.$refs.productsFloat.offsetTop + this.$refs.productsFloat.offsetHeight / 2}px`;
				this.$refs.desktopSwipeContainerPrev.style.top = top;
				this.$refs.desktopSwipeContainerNext.style.top = top;
				this.$refs.desktopSwipeContainerPrev.style.left = `${this.$refs.floatSwipeContainer.$el.offsetLeft}px`;
				this.$refs.desktopSwipeContainerNext.style.left = `${this.$refs.floatSwipeContainer.$el.offsetLeft + this.$refs.floatSwipeContainer.$el.offsetWidth}px`;
			} else {
				let top = `${this.$refs.desktopSwipeContainer.$el.offsetTop + this.$refs.products.offsetHeight / 2}px`;
				this.$refs.desktopSwipeContainerPrev.style.top = top;
				this.$refs.desktopSwipeContainerNext.style.top = top;
				this.$refs.desktopSwipeContainerPrev.style.left = "auto";
				this.$refs.desktopSwipeContainerNext.style.left = "auto";
			}
		},
		initDOMActions() {
			this.initProductCards();

			if (this.isAdaptive) {
				this.initSliderEvents();
				this.io.observe(this.$refs.floatBlockContainer);
			} else {
				this.calcSwipeControlsPosition();
				this.io.observe(this.$refs.products);
			}
		},
		addItemsToCart(products) {
			products.forEach(id => {
				let items = document.querySelectorAll(`[data-item-id="${id}"]`);
				$(items).parents("[data-to-cart]").addClass("in-cart");
			});
		},
		toggleCategoryItem(category) {
			if (this.isActiveCategoryItem(category)) {
				var index = this.activeCategories.indexOf(category.category);
				if (index !== -1) {
					this.activeCategories.splice(index, 1);
				}
			} else {
				this.activeCategories.push(category.category);
			}
		},
		isActiveCategoryItem(category) {
			return this.activeCategories.includes(category.category);
		},
	},
	watch: {
		activeCategory() {
			this.$nextTick(() => {
				this.initProductCards();
				if (!this.isAdaptive) {
					if (this.$refs.desktopSwipeContainer) this.$refs.desktopSwipeContainer.refresh();
				} else {
					this.initSliderEvents();
				}
			});
		},
		isAdaptive() {
			this.$nextTick(() => this.initDOMActions());
		},
		addedToCart(added) {
			this.addItemsToCart(added);
		},
		floatBlock(val) {
			let headerSelector = (this.isAdaptive) ? ".main-header" : ".main-header.is-fixed";
			let header = document.querySelector(headerSelector);

			if (!header) return;

			if (val) {
				if (!this.isAdaptive) {
					this.$refs.productsFloat.style.top = `${header.offsetHeight}px`;
					this.$nextTick(() => {
						this.$refs.floatSwipeContainer.setScroll(this.currentScrollLeft);
						this.$nextTick(() => this.calcSwipeControlsPosition(true));
					}, 0);
				} else {
					this.$refs.floatBlock.style.top = `${header.offsetHeight}px`;
				}
			} else {
				this.calcSwipeControlsPosition();
			}
		}
	},
	mounted() {
		let self = this;
		if (this.hasProducts) {
			window.onresize = debounce(() => {
				this.windowWidth = window.innerWidth;
			}, 150);

			this.$nextTick(() => {
				this.initDOMActions();
				this.isLoading = false;
			});
		} else {
			this.isLoading = false;
		}

		$('body').on('click', '[data-product-card-remove]', function(e){
			e.preventDefault();
			self.removeProduct($(this).data('item-id'));
		})
	},
	created() {
		this.activeProductLeft = Object.keys(this.products)[0];
		this.activeProductRight = Object.keys(this.products)[1] || Object.keys(this.products)[0];
		this.activeCategory = this.categories[0];

		this.io = new IntersectionObserver(this.ioCallback, {
			threshold: 0
		});
	}
}
